import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import { Layout, Carousel } from 'antd';

import classes from './HomeHeader.css'

import coronaImage1 from "../../assets/img/corona_0.jpg";
import coronaImage2 from "../../assets/img/corona_1.jpg";
import { withNamespaces } from 'react-i18next';
import { getTheme } from '../../reducers/theme/selectors';
import { connect } from 'react-redux';


const { Content } = Layout;


class HomeHeader extends React.Component {

    render() {
        return (
            <div>
              <div className={classes.header}>
                <h2 className={classes.headerHeading}><Link to='/'>
                    <img alt="diamond-trial-logo" src={this.props.theme.logo_light} style={{ objectFit: 'contain', width: '90px', height: 'auto', margin: '6px 10px 0 0' }} />
                    DCTMS Trial
                </Link></h2>

                <ul className={classes.headerMenu}>
                  <li><NavLink exact to='/' activeClassName="active">{this.props.i18n.t('NamespaceHomeHeader:Home')}</NavLink></li>
                  <li><NavLink exact to='/documents' activeClassName="active">{this.props.i18n.t('NamespaceHomeHeader:Documents')} </NavLink></li>
                  <li><NavLink exact to='/contact-us' activeClassName="active">{this.props.i18n.t('NamespaceHomeHeader:Contact Us')} </NavLink></li>
                </ul>
              </div>

              {this.props.children || <Carousel className={classes.carousel}>
                <div>
                  <div className={classes.carouselItem} style={{ backgroundImage: `url(${coronaImage1})`, justifyContent: 'center' }}>
                    <div className={classes.carouselItemContentWrapper}>
                      <div className={classes.carouselItemContent1}>
                        <h2>{this.props.i18n.t('NamespaceHomeHeader:Welcome')}</h2>
                        <p>{this.props.i18n.t('NamespaceHomeHeader:To The Official Site For The DCTMS Trial')}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className={classes.carouselItem} style={{ backgroundImage: `url(${coronaImage2})` }}>
                    <div className={classes.carouselItemContent2}>
                        <h2>{this.props.i18n.t('NamespaceHomeHeader:Welcome')}</h2>
                        <p>{this.props.i18n.t('NamespaceHomeHeader:To The Official Site For The DCTMS Trial')}</p>
                    </div>
                  </div>
                </div>
              </Carousel>}
            </div>
        );
    }
}

export default connect(state => ({
  theme: getTheme(state)
}))(withNamespaces()(HomeHeader));



// WEBPACK FOOTER //
// ./src/components/HomeHeader/HomeHeader.js